document.querySelectorAll('.footer-column h4').forEach((header) => {
    header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        if (content) {
            header.classList.toggle('expanded');
            content.classList.toggle('active');
        }
    });
});